export class IsiPageRequestManagerResponse {

    IsiData: any;

    constructor() {
        // <summary>
        // Représente un évènement composant
        // </summary>
        // <history>
        // LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        // <history>
        this.IsiData;
    }
}